import { app } from '../../../../../bootstrap/core';
import {
  receivingCreateRequestState,
  receivingCreateRequestStateName,
} from './createRequest.state';
import { receivingCreateRequestComponent } from './createRequest.component';
import { ReceivingCreateRequestService } from './createRequest.service';
import { CreateRequestModalActionService } from './createRequest.modal.action.service';
import '../../../../../common/ui/paymentPartners/paymentPartners';
import duplicateDialogBody from './partials/duplicateDialogBody.tpl.html';
import { HotkeyService } from '../hotkey.service';

import './components/components';

app.config(receivingCreateRequestState);
app.constant(
  'receivingCreateRequestStateName',
  receivingCreateRequestStateName,
);
app.component(
  receivingCreateRequestComponent.name,
  receivingCreateRequestComponent,
);
app.value('duplicateDialogBody', duplicateDialogBody);
app.service('receivingCreateRequestService', ReceivingCreateRequestService);
app.service('modalActionService', CreateRequestModalActionService);
app.service('hotkeyService', HotkeyService);
